import angular from 'angular';
import '../core.module';
import { User } from '../models/user.model';

class SessionService {
  constructor(StorageService, STORAGE_KEYS) {
    this.StorageService = StorageService;
    this.STORAGE_KEYS = STORAGE_KEYS;
    const storedUser = this.StorageService.get(STORAGE_KEYS.CURRENT_USER);
    this.user = storedUser ? new User(storedUser) : null;
    this.token = this.StorageService.get(STORAGE_KEYS.AUTH_TOKEN);
    this.refreshToken = this.StorageService.get(STORAGE_KEYS.REFRESH_TOKEN);
    this.tenantSlug = this.StorageService.get(STORAGE_KEYS.TENANT_SLUG);
  }

  isAuthenticated() {
    return Boolean(this.token && this.user);
  }

  hasPermission(permission) {
    return this.user ? this.user.hasPermission(permission) : false;
  }

  setSession(user, token, refreshToken, tenantSlug) {
    this.user = new User(user);
    this.token = token;
    this.refreshToken = refreshToken;
    this.tenantSlug = tenantSlug;
    this.StorageService.set(this.STORAGE_KEYS.CURRENT_USER, this.user);
    this.StorageService.set(this.STORAGE_KEYS.AUTH_TOKEN, token);
    this.StorageService.set(this.STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
    this.StorageService.set(this.STORAGE_KEYS.TENANT_SLUG, tenantSlug);
  }

  updateUser(user) {
    this.user = new User(user);
    this.StorageService.set(this.STORAGE_KEYS.CURRENT_USER, this.user);
  }

  clearSession() {
    this.user = null;
    this.token = null;
    this.refreshToken = null;
    this.StorageService.remove(this.STORAGE_KEYS.CURRENT_USER);
    this.StorageService.remove(this.STORAGE_KEYS.AUTH_TOKEN);
    this.StorageService.remove(this.STORAGE_KEYS.REFRESH_TOKEN);
  }
}

SessionService.$inject = ['StorageService', 'STORAGE_KEYS'];

angular.module('app.core').service('SessionService', SessionService);

export default SessionService;
